export class CreateThumbnail {
  // This static property will hold the currently active thumbnail.
  private static activeThumbnail: HTMLElement | null = null;
  private static selectedThumbnail: HTMLElement | null = null;

  public generateThumbnail(
    id: string,
    imageSrc: string,
    thumbnail: string,
    dataAttribute?: { key: string; value: string },
    dataAttribute2?: { key: string; value: string },
    dataAttribute3?: { key: string; value: string },
    dataAttribute4?: { key: string; value: string },
    dataAttribute5?: { key: string; value: string }
  ): HTMLElement {
    // Create the main thumbnail div with class 'cc-thumbnail'
    const thumbnailDiv = document.createElement('div');
    thumbnailDiv.className = 'cc-thumbnail';

    // Create the content div with class 'cc-thumbnail_content'
    const contentDiv = document.createElement('div');
    contentDiv.className = 'cc-thumbnail_content';

    // Create the image with class 'cc-thumbnail_image'
    const thumbnailImage = document.createElement('img');
    thumbnailImage.className = 'cc-thumbnail_image';

    thumbnailImage.src = thumbnail;
    // thumbnailImage.mainUrl = imageSrc;

    //
    // Create the image with class 'cc-thumbnail_image'
    // disabled for now
    //const deleteIcon = document.createElement('div');
    //deleteIcon.className = 'cc-thumbnail_delete';

    // Create the overlay div with class 'cc-thumbnail_active'
    const overlayDivActive = document.createElement('div');
    overlayDivActive.className = 'cc-thumbnail_active';
    overlayDivActive.style.display = 'none'; // Hide by default

    // Create the overlay div with class 'cc-thumbnail_active'
    const overlayDivPreview = document.createElement('div');
    overlayDivPreview.className = 'cc-thumbnail_preview';
    overlayDivPreview.style.display = 'none'; // Hide by default

    // If a data attribute is provided, set it on the image.
    if (dataAttribute) {
      thumbnailDiv.setAttribute(`data-${dataAttribute.key}`, dataAttribute.value);
    }
    if (dataAttribute2) {
      thumbnailDiv.setAttribute(`data-${dataAttribute2.key}`, dataAttribute2.value);
      //deleteIcon.setAttribute(`data-${dataAttribute2.key}`, dataAttribute2.value);
    }
    if (dataAttribute3) {
      thumbnailDiv.setAttribute(`data-${dataAttribute3.key}`, dataAttribute3.value);
      //deleteIcon.setAttribute(`data-${dataAttribute2.key}`, dataAttribute2.value);
    }
    if (dataAttribute4) {
      thumbnailDiv.setAttribute(`data-${dataAttribute4.key}`, dataAttribute4.value);
      //deleteIcon.setAttribute(`data-${dataAttribute2.key}`, dataAttribute2.value);
    }
    if (dataAttribute5) {
      thumbnailDiv.setAttribute(`data-${dataAttribute5.key}`, dataAttribute5.value);
      //deleteIcon.setAttribute(`data-${dataAttribute2.key}`, dataAttribute2.value);
    }
    if (id) {
      thumbnailDiv.setAttribute('data-id', id);
      // deleteIcon.setAttribute('data-id', id);
    }

    // Append the image and overlay to the content div
    contentDiv.appendChild(thumbnailImage);
    //thumbnailDiv.appendChild(deleteIcon);
    contentDiv.appendChild(overlayDivActive);
    contentDiv.appendChild(overlayDivPreview);

    // Append the content div to the main thumbnail div
    thumbnailDiv.appendChild(contentDiv);

    // Attach an event listener to the thumbnailDiv to toggle the active state on click
    thumbnailDiv.addEventListener('click', () => {
      // If there's a previously active thumbnail, deactivate it
      if (CreateThumbnail.activeThumbnail) {
        const previousOverlay = CreateThumbnail.activeThumbnail.querySelector(
          '.cc-thumbnail_preview'
        ) as HTMLElement;
        if (previousOverlay) {
          previousOverlay.style.display = 'none';
        }
      }

      // Set the current thumbnail as active and show its overlay
      overlayDivPreview.style.display = 'block';
      CreateThumbnail.activeThumbnail = thumbnailDiv;
    });

    // Return the main thumbnail div
    return thumbnailDiv;
  }
  /**
   * Set the thumbnail with the provided id as SELECTED.
   * @param id - The id of the thumbnail to set as SELECTED.
   */
  public static setSelectedThumbnail(id: string): HTMLElement | undefined {
    // Get the thumbnail with the provided id
    const thumbnailToSelect = document.querySelector(
      `.cc-thumbnail[data-image-id="${id}"]`
    ) as HTMLElement;

    // If there's a previously selected thumbnail, deactivate its overlay
    if (CreateThumbnail.selectedThumbnail) {
      const previousSelectedOverlay = CreateThumbnail.selectedThumbnail.querySelector(
        '.cc-thumbnail_active'
      ) as HTMLElement;
      if (previousSelectedOverlay) {
        previousSelectedOverlay.style.display = 'none';
      }
    }

    if (thumbnailToSelect) {
      // Set the current thumbnail as active and show its overlay
      const overlayToActivate = thumbnailToSelect.querySelector(
        '.cc-thumbnail_active'
      ) as HTMLElement;
      if (overlayToActivate) {
        overlayToActivate.style.display = 'block';
      }

      // Update the static selectedThumbnail property
      CreateThumbnail.selectedThumbnail = thumbnailToSelect;
      return thumbnailToSelect;
    }
  }
}
